'use client'
import React, { useState, useContext } from 'react'
import InputDefault from '../forms/InputDefault'
import { CommentAPI } from '../../../data/socialize'
import ButtonWSpinner from '../buttons/ButtonWSpinner'
import { UserContext } from '../../../contexts/UserContext'
import LoginSuggestion from '../authentication/LoginSuggestion'
import LoginModal from '../authentication/LoginModal'
import { usePathname } from 'next/navigation'
import { revalidatePathServer } from '@/library/editor/utilsServer'
import { COUNTRY_UAE_ID } from '@/data/constants'



export default function CommentCreateForm(props) {
  const {
    thread,
    onSuccess = () => { },
    className = "",
    countryId = COUNTRY_UAE_ID,
  } = props
  const { isAuthenticated } = useContext(UserContext)
  const threadPk = thread.pk
  const [formData, setFormData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  
  const pathname = usePathname()

  const handleOnChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleOnSubmit = async (e) => {
    setIsLoading(true)
    e.preventDefault()
    const data = await CommentAPI.create(threadPk, formData.content)
    setFormData({})
    revalidatePathServer(pathname)
    setIsLoading(false)
    onSuccess(threadPk)
  }

  

  const renderForm = () => {
    return (
      <form className="grid grid-cols-12 gap-2" 
        onSubmit={handleOnSubmit}
      >
        <InputDefault
          className="col-span-9"
          name="content" type="text" label={null}
          placeholder="Please enter your thoughts"
          formData={formData} errors={{}}
          onChange={handleOnChange}
          size="sm"
        />
        <ButtonWSpinner
          label="Send"
          color="primary"
          variant="flat"
          className="col-span-3 h-full"
          isLoading={isLoading}
          disabled={!isAuthenticated}
          type="submit"
        />
      </form>
    )
  }

  return (
    <div className={`mt-2 ${className}`}>
      {isAuthenticated ? renderForm()
      : <>
        <LoginModal countryId={countryId} size="md" trigger={renderForm()} />
      </>}


    </div>
  )
}
